import { isNewLayoutsMigrated } from '@goldcast/player-config/src/utils/clipUtils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';

/**
 * Shown below the aspect ratio options in the new layouts popover when the clip hasn't
 * been migrated to use the new layouts engine yet (`asset_metadata.is_new_layouts_migrated`
 * is falsy). Migration itself now happens automatically the moment the user picks a layout
 * (from this popover or the scene layout dropdown), so this is a passive notice rather than
 * an action the user needs to take. Gated behind `Use_CL_Editor_New_Layouts` since this popover
 * only renders when that flag is on, but the check is kept here too for safety.
 */
const ClipCustomizerNewLayoutsMigrateNudge = () => {
  const { clipData } = useClipsContext();
  const isNewLayoutsFeatureEnabled = !!featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Editor_New_Layouts];

  if (!isNewLayoutsFeatureEnabled || isNewLayoutsMigrated(clipData)) {
    return null;
  }

  return (
    <div className="rounded-md border border-black border-opacity-10 bg-orange-50 px-3 py-2.5 text-sm">
      <div className="font-medium">We&apos;ve upgraded layouts</div>
      <div className="mt-1 font-light">
        Your clip is unchanged. Select a new layout below to apply the updated experience.
      </div>
    </div>
  );
};

export default ClipCustomizerNewLayoutsMigrateNudge;
